/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A3Inputs */

const en_to_csv_faq_a3 = /** @type {(inputs: To_Csv_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The header row is the union of every key found across all records, ordered by when each key was first seen. A record that lacks one of those keys gets an empty cell for it.`)
};

const ko_to_csv_faq_a3 = /** @type {(inputs: To_Csv_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤더 행은 모든 레코드에서 발견된 모든 키의 합집합이며, 각 키가 처음 등장한 시점으로 순서가 정해집니다. 그 키가 없는 레코드는 해당 칸이 비어 있게 됩니다.`)
};

const ja_to_csv_faq_a3 = /** @type {(inputs: To_Csv_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダ行はすべてのレコードで見つかったすべてのキーの和集合で、各キーが最初に現れた時点で順序が決まります。そのキーを持たないレコードは、その列が空のセルになります。`)
};

/**
* | output |
* | --- |
* | "The header row is the union of every key found across all records, ordered by when each key was first seen. A record that lacks one of those keys gets an emp..." |
*
* @param {To_Csv_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a3 = /** @type {((inputs?: To_Csv_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a3(inputs)
	if (locale === "ko") return ko_to_csv_faq_a3(inputs)
	return ja_to_csv_faq_a3(inputs)
});